import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationWaitingTime from "../../../components/organization/reports/daily/OrganizationWaitingTime";
import {
  WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationWaitingTimePage = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS}
    descriptionKey="WaitingTime"
    title={`${reportIndex}. Waiting Time`}
  >
    {({ data, renderConfig }) => (
      <OrganizationWaitingTime reportIndex={reportIndex} data={data[0]} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationWaitingTimePage;
